import './cadastro.css';
import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import Checkbox from '../../../rxlib/components/checkbox';
import InputLabel from '../../../rxlib/components/input-label';
import TextareaLabel from '../../../rxlib/components/textarea-label';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { SelectLabelAsync } from '../../../rxlib/components/select/select-label-async';
import { ApiError, ItemLicencaBaseTemp, ItemLicencaBase } from '../../../services/tipos';

interface ItemLicencaBaseCadastroProps {
    show: boolean;
    readOnly: boolean;
    onHide: () => void;
    idLicencaBase: string;
    idItemLicencaBaseTemp: string;
    fonteDados: [ItemLicencaBaseTemp];
    onSalvar: (valor: boolean) => void;
    setFonteDados: (fonteDados: [ItemLicencaBaseTemp]) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function ItemLicencaBaseCadastro(props: ItemLicencaBaseCadastroProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [tipoControleItemLicencaBase, setTipoControleItemLicencaBase] = useState<number>(0);

    const [itemLicencaBase, setItemLicencaBase] = useState<ItemLicencaBase>({
        id: '',
        valorItem: '',
        idItemLicenca: '',
        personalizado: false,
    });

    const tipoControleFlag = 2;
    const tipoControlePersonalizado = 3;

    const { register, handleSubmit } = useForm<ItemLicencaBaseTemp>();

    const onHideWarning = () => {
        setShowWarning(false);
    }

    const temPermissao = props.readOnly
        ? usuarioTemPermissao(token, 'itens_licenca_base_visualizar')
        : props.idItemLicencaBaseTemp
            ? usuarioTemPermissao(token, 'itens_licenca_base_editar')
            : usuarioTemPermissao(token, 'itens_licenca_base_novo');

    useEffect(() => {
        setItemLicencaBase({
            id: '',
            valorItem: '',
            idItemLicenca: '',
            personalizado: false,
        });

        if (temPermissao) {
            if (props.idItemLicencaBaseTemp) {
                let item = props.fonteDados.filter((item) => String(item.tempId) === String(props.idItemLicencaBaseTemp));
                if (item.length > 0) {
                    setItemLicencaBase({
                        id: item[0].id,
                        valorItem: item[0].valorItem,
                        personalizado: item[0].personalizado,
                        idItemLicenca: item[0].itemLicenca.id,
                    });
                }
            }
        } else {
            setCarregando(false);
            setMessageWarning(['Usuário logado não tem permissão para realizar essa ação com o item da licença base.']);
            setShowWarning(true);
        }
    }, [props, temPermissao]);

    const onSubmit: SubmitHandler<ItemLicencaBaseTemp> = data => {
        if (!tipoControleEPersonalizado()) {
            if (tipoControleEFlag()) {
                if ((data.valorItem !== '0') && (data.valorItem !== '1')) {
                    setMessageWarning(['Itens do tipo flag permitem apenas os valores 0 ou 1.']);
                    setShowWarning(true);
                } else {
                    salvar(data);
                }
            } else {
                salvar(data);
            }
        } else {
            salvar(data);
        }
    }

    function salvar(data: ItemLicencaBaseTemp) {
        setCarregando(true);
        api.get(`/ItemLicenca/${data.idItemLicenca}`)
            .then(response => {
                let dados: ItemLicencaBaseTemp = {
                    id: data.id,
                    valorItem: data.valorItem,
                    idLicencaBase: data.idLicencaBase,
                    idItemLicenca: data.idItemLicenca,
                    personalizado: Boolean(data.personalizado),
                    tempId: (props.idItemLicencaBaseTemp !== '') ? parseInt(props.idItemLicencaBaseTemp) : obterProximoTempId(),
                    itemLicenca: {
                        id: response.data.id,
                        nome: response.data.nome,
                        chave: response.data.chave,
                        tipoControle: response.data.tipoControle,
                    },
                };

                props.idItemLicencaBaseTemp
                    ? editar(dados)
                    : incluir(dados);
            });
    }

    function obterProximoTempId() {
        let proximo = 0;
        for (var contador = 0; contador < props.fonteDados.length; contador++) {
            if (props.fonteDados[contador].tempId > proximo)
                proximo = props.fonteDados[contador].tempId;
        }
        return proximo + 1;
    }

    function incluir(data: ItemLicencaBaseTemp) {
        try {
            let novosDados = props.fonteDados;
            if (novosDados[0].tempId === 0) {
                novosDados[0] = data;
            } else {
                novosDados.push(data);
            }

            props.setFonteDados(novosDados);
            informarSucesso();
        } catch (error: any) {
            setCarregando(false);
            props.tratarErro(error, 'Não foi possível salvar o item da licença base: ');
        }
    }

    function editar(data: ItemLicencaBaseTemp) {
        let dados: [ItemLicencaBaseTemp] = [{
            id: '',
            tempId: 0,
            valorItem: '',
            idLicencaBase: '',
            idItemLicenca: '',
            personalizado: false,
            itemLicenca: {
                id: '',
                nome: '',
                chave: '',
                tipoControle: '',
            },
        }];

        function AddItemDados(item: ItemLicencaBaseTemp) {
            if (String(item.tempId) !== String(data.tempId)) {
                if (!dados[0]['tempId']) {
                    dados[0] = item;
                } else {
                    dados.push(item);
                }
            }
        }

        try {
            props.fonteDados.map(item => (
                AddItemDados(item)
            ));

            if (dados[0].tempId === 0) {
                dados[0] = data;
            } else {
                dados.push(data);
            }

            props.setFonteDados(dados);
            informarSucesso();
        } catch (error: any) {
            setCarregando(false);
            props.tratarErro(error, 'Não foi possível salvar o item da licença base: ');
        }
    }

    function informarSucesso() {
        props.onHide();
        props.onSalvar(true);
        setCarregando(false);
    }

    function onChangeItemLicenca(idItemLicenca: string) {
        api.get(`/ItemLicenca/${idItemLicenca}`)
            .then(response => {
                setTipoControleItemLicencaBase(response.data.tipoControle);
            });
    }

    function tipoControleEFlag(): boolean {
        return (tipoControleItemLicencaBase === tipoControleFlag);
    }

    function tipoControleEPersonalizado(): boolean {
        return (tipoControleItemLicencaBase === tipoControlePersonalizado);
    }

    function getDialogClassName(): string {
        let modalContent: string = (props.idItemLicencaBaseTemp !== '')
            ? tipoControleEPersonalizado()
                ? 'naja-modal-content-item-licenca-base-view-personalizado'
                : 'naja-modal-content-item-licenca-base-view'
            : tipoControleEPersonalizado()
                ? 'naja-modal-content-item-licenca-base-personalizado'
                : 'naja-modal-content-item-licenca-base';

        return 'naja-modal-item-licenca-base ' + modalContent;
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} dialogClassName={getDialogClassName()} centered>
                <Modal.Body className='naja-modal-body-detalhe-item-licenca-base'>
                    <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                        <div className='container-fluid'>
                            <div className='row px-1'>
                                <div className='col-11'>
                                    <h6>{props.readOnly ? 'Visualizar' : props.idItemLicencaBaseTemp ? 'Editar' : 'Novo'} item da licença base</h6>
                                </div>
                                <div className='col-1 naja-btn-close-cell-detalhe-item-licenca-base'>
                                    <button type='button' className='btn-close' aria-label='Close' onClick={props.onHide} />
                                </div>
                            </div>
                            {
                                itemLicencaBase.id
                                    ? <div className='row px-1'>
                                        <div className='col-12 mt-1'>
                                            <InputLabel
                                                name='id'
                                                type='text'
                                                maxLength={50}
                                                readOnly={true}
                                                label='Código:'
                                                autoFocus={false}
                                                id='inputIdDetalhe'
                                                defaultValue={itemLicencaBase.id}
                                                className='rxlib-input-label-coluna'
                                                referencia={register({ required: true })}
                                                placeholder='Código do item da licença base' />
                                        </div>
                                    </div>
                                    : props.idItemLicencaBaseTemp
                                        ? <div className='row px-1'>
                                            <div className='col-12 mt-1'>
                                                <InputLabel
                                                    type='text'
                                                    maxLength={50}
                                                    readOnly={true}
                                                    autoFocus={false}
                                                    id='inputIdDetalhe'
                                                    label='Código temporário:'
                                                    name='idItemLicencaBaseTemp'
                                                    className='rxlib-input-label-coluna'
                                                    referencia={register({ required: true })}
                                                    defaultValue={props.idItemLicencaBaseTemp}
                                                    placeholder='Código do item da licença base' />
                                            </div>
                                        </div>
                                        : ''
                            }
                            <div className='row px-1 d-none'>
                                <div className='col-12 mt-1'>
                                    <InputLabel
                                        type='text'
                                        maxLength={50}
                                        readOnly={true}
                                        autoFocus={false}
                                        name='idLicencaBase'
                                        id='inputIdLicencaBase'
                                        label='Código da licença base:'
                                        placeholder='Código da licença base'
                                        className='rxlib-input-label-coluna'
                                        referencia={register({ required: true })}
                                        defaultValue={props.idLicencaBase ? props.idLicencaBase : '0'} />
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-1'>
                                    <SelectLabelAsync
                                        foco='sim'
                                        type='ItemLicenca'
                                        name='idItemLicenca'
                                        id='inputIdItemLicenca'
                                        label='Item de licença:'
                                        action={props.readOnly ? 'view' : ''}
                                        className='rxlib-select-label-coluna'
                                        referencia={register({ required: true })}
                                        onChangeValueSelected={onChangeItemLicenca}
                                        valorSelecionado={itemLicencaBase.idItemLicenca} />
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-1'>
                                    {
                                        (tipoControleEPersonalizado())
                                            ? <TextareaLabel
                                                rows={10}
                                                size='coluna'
                                                label='Valor:'
                                                name='valorItem'
                                                maxLength={2000}
                                                autoFocus={false}
                                                id='inputValorItem'
                                                readOnly={props.readOnly}
                                                placeholder='Valor do item'
                                                defaultValue={itemLicencaBase.valorItem}
                                                referencia={register({ required: true })} />
                                            : <InputLabel
                                                type='text'
                                                maxLength={2}
                                                mask='number'
                                                label='Valor:'
                                                name='valorItem'
                                                autoFocus={false}
                                                id='inputValorItem'
                                                readOnly={props.readOnly}
                                                placeholder='Valor do item'
                                                className='rxlib-input-label-coluna'
                                                defaultValue={itemLicencaBase.valorItem}
                                                referencia={register({ required: true })} />
                                    }
                                </div>
                            </div>
                            <div className='row px-1'>
                                <div className='col-12 mt-2'>
                                    <Checkbox
                                        name='personalizado'
                                        referencia={register}
                                        disabled={props.readOnly}
                                        value={String(itemLicencaBase.personalizado)}
                                        text='Permitir personalização por organização'
                                        defaultChecked={itemLicencaBase.personalizado} />
                                </div>
                            </div>
                            <ButtonsCrud
                                carregando={carregando}
                                styleButton='btn-rxlib'
                                visualizar={props.readOnly}
                                onCancelarVoltar={props.onHide} />
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <ModalWarning
                show={showWarning}
                onHide={onHideWarning}
                message={messageWarning} />
        </>
    );
}

export default ItemLicencaBaseCadastro;